<template>
  <v-app id="app">
    <v-snackbar
      :absolute="notification.absolute"
      :multi-line="notification.multiLine"
      :color="notification.color"
      :bottom="notification.bottom"
      :left="notification.left"
      :right="notification.right"
      :top="notification.top"
      :centered="notification.centered"
      v-model="notification.status"
      :timeout="-1"
    >
      {{ notification.message }}
      <template v-slot:action>
        <v-icon @click="closeNotification()" right class="white--text">mdi-close</v-icon>
      </template>
    </v-snackbar>
    <template v-if="$auth.ready()">
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="text-center mt-5">
        <v-progress-circular indeterminate color="secondary" width="3" size="80"></v-progress-circular>
      </div>
    </template>
  </v-app>
</template>

<style lang="scss">
// chips
.table-chips {
  height: 20px !important;
}
// form
.app-form {
  textarea {
    font-size: 1rem !important;
  }
  .v-messages,
  .v-counter {
    font-size: 1rem !important;
  }
  .v-text-field__details {
    padding: 0 !important;
  }
  .v-text-field--outlined fieldset {
    border-width: 2px;
  }
}
// datatable
.app-datatable {
  thead {
    tr {
      th {
        font-size: 1rem !important;
      }
    }
  }
  tbody {
    tr {
      td {
        font-size: 0.92rem !important;
      }
    }
  }
}
// list
.app-list {
  padding: 0 !important;
}
// file upload
.file-uploads {
  overflow: initial !important;
}
// vuebar
.vb {
  & > .vb-dragger {
    z-index: 5;
    width: 12px;
    right: 0;

    & > .vb-dragger-styler {
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform: rotate3d(0, 0, 0, 0);
      transform: rotate3d(0, 0, 0, 0);
      -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out,
        height 100ms ease-out;
      transition: background-color 100ms ease-out, margin 100ms ease-out,
        height 100ms ease-out;
      background-color: rgba(29, 70, 210, 0.1);
      margin: 5px 5px 5px 0;
      height: calc(100% - 10px);
      display: block;
    }

    &:hover {
      & > .vb-dragger-styler {
        background-color: rgba(29, 70, 210, 0.5);
        margin: 0px;
        height: 100%;
      }
    }
  }

  &.vb-scrolling-phantom {
    & > .vb-dragger {
      & > .vb-dragger-styler {
        background-color: rgba(29, 70, 210, 0.3);
      }
    }
  }

  &.vb-dragging {
    & > .vb-dragger {
      & > .vb-dragger-styler {
        background-color: rgba(29, 70, 210, 0.5);
        margin: 0px;
        height: 100%;
      }
    }
  }

  &.vb-dragging-phantom {
    & > .vb-dragger {
      & > .vb-dragger-styler {
        background-color: rgba(29, 70, 210, 0.5);
      }
    }
  }
}
// error
.titleError {
  font-size: 150px;
  height: 180px;
}

.actions-bloc {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;

  div {
    flex: initial;
  }
}

// fonts
.primary-font {
  font-family: 'Lato' sans-serif !important;
}
.secondary-font {
  font-family: 'Montserrat', sans-serif !important;
}
</style>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  created() {
    // set moment locale
    Vue.moment().locale(this.$vuetify.lang.current);
  },
  metaInfo() {
    return {
      title: this.$vuetify.lang.t("$vuetify.app_description"),
      titleTemplate: "%s - BulkSMS",
    };
  },
  data: () => ({}),
  methods: {
    ...mapActions({
      closeNotification: "notification/close",
    }),
  },
  computed: {
    ...mapGetters({ notification: "notification/notification" }),
  },
};
</script>
